module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/11-1c44096a2664ba4c21a9b96171509eb6.jpg";